import { ILanguage } from './typescript'

export function setWholePageDirection(language: ILanguage) {}
